var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-numeric-input',{attrs:{"value":_vm.inputValue,"currency-sign":_vm.currency,"usage":_vm.usage,"readOnly":_vm.readOnly,"has-negative":false},on:{"input":_vm.onValueChanged,"blur":function($event){return _vm.$emit('blur')}}})}
var staticRenderFns = []

export { render, staticRenderFns }